import { render, staticRenderFns } from "./coverupload.vue?vue&type=template&id=151c285c&scoped=true&"
import script from "./coverupload.vue?vue&type=script&lang=js&"
export * from "./coverupload.vue?vue&type=script&lang=js&"
import style0 from "./coverupload.vue?vue&type=style&index=0&id=151c285c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151c285c",
  null
  
)

export default component.exports